import useAxios from "@hooks/useFetch";
import { components, paths } from "@api/api";
import { useCallback } from "react";
import { useMappedFiltersToApi } from "@vms/SelectFilters/SelectFiltersContext";

const REQUEST_URL: keyof paths = '/Byo';
export type Request = components["schemas"]["Application.Byo.Models.ByoFilterInput"];
export type Response = components["schemas"]["Application.Byo.Models.ByoViewModel"][];

export function useGetByo() {
    const filtersToApi = useMappedFiltersToApi();

    const request = useAxios<Response, Request>({
        url: REQUEST_URL,
        method: 'post',
        lazy: true,
        keepMultiple: true,
    });

    const doFetch = useCallback(
        async (
            words: Request['words'],
        ) => {
            const requestData: Request = {
                filters: filtersToApi,
                words,
            };

            return request.doFetch({
                data: requestData,
            });
        },
        [request, filtersToApi]
    );

    return {
        ...request,
        doFetch,
    };
}
